import * as React from 'react';

import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';
import { ConfigurationForm } from '../../containers/ConfigurationForm/ConfigurationForm';
import { Panel } from '@watcherr/ui';

const ConfigurationPage = () => (
  <>
    <Panel>
      <ConfigurationForm />
    </Panel>
  </>
);

export default dashboardWrapper(ConfigurationPage, t('menu.dashboard.configuration'));
